<template>
  <el-dialog :title="title" :visible.sync="dialogMonth" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <div style="display: flex;margin-bottom: 8px;padding-left: 5px;" v-if="isSJ||isTZ">
        <div style="width: 40px;height: 20px; background-color:#F56C6C; border-radius: 5px; margin-right: 3px;"></div><div>当前数据被调整</div>
      </div>
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini" style="width: 100%;">
         <el-form-item >
           <el-button type="primary" size="mini" v-if="isSJ" :disabled='isDisable' @click="daochuFn">导出详情</el-button>
          </el-form-item>
         <el-form-item >
           <p class="margin0">计划收入合计:<span class="red">{{mapData.predictedIncome}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">计划支出合计:<span class="red">{{mapData.predictedExpense}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际收入合计:<span class="red">{{mapData.actualIncome}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际支出合计:<span class="red">{{mapData.actualExpense}}</span>万元</p>
          </el-form-item>
      </el-form>
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border
      :header-cell-class-name="addStar" :height="tableHeight" :key="tableKey" :row-style="setRowStyle"  >
        <el-table-column type="index" prop="date" width="55" label="序号" fixed></el-table-column>
        <el-table-column width="120" label="操作" fixed>
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="submitClick(scope.row)" v-if="scope.row.isEditing">保存</el-button>
              <el-button v-if="!scope.row.isEditing" type="text" size="mini" @click="editClick(scope.row, scope.$index)">修改</el-button>
              <!-- 普通的删除 -->
              <el-button type="text" size="mini" v-if="!isSJ&&!isTZ" @click="delMaterial(scope.row,scope.$index)">删除</el-button>
              <!-- 实际收支的删除 收支合计为0可以删除-->
              <el-button type="text" size="mini" v-if="isSJ&&scope.row.predictedAmount=='0'" @click="delMaterial(scope.row,scope.$index)">删除</el-button>
              <!-- 调整的删除 实际收支大于0不能删除 -->
              <el-button type="text" size="mini" v-if="isTZ&&!scope.row.actualAmount>0" @click="delMaterial(scope.row,scope.$index)">删除</el-button>
              <el-button type="text" size="mini" @click="fuzhiFn(scope.row)" v-if="!isSJ&&!isTZ" >复制</el-button>
              <el-button type="text" size="mini" @click="addRowFn(scope.row)" v-if="scope.$index === tableDataList.length - 1" >新增行</el-button>
              <el-button type="text" size="mini" v-if="isTZ&&scope.row.adjustFlag==1" @click="tiaozhengjiluFN(scope.row)">调整记录</el-button>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="adjustRemark" width="150" label="调整备注" v-if="isTZ">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.adjustRemark }}</span>
              <el-input v-else v-model="scope.row.adjustRemark" placeholder="请输入" size="mini"></el-input>
             </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="incomeExpenseType" width="80" label="收支类型">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing || scope.row.id">{{ scope.row.incomeExpenseType == 0 ? '收款' : '付款' }}</span>
              <el-select v-else v-model="scope.row.incomeExpenseType" placeholder="请选择" size="mini" @change="shouzhiChange(scope.row)">
                <el-option label="收款" value="0" ></el-option>
                <el-option label="付款" value="1" ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="actualAmount" width="200" label="实际收支(万元)" v-if="isSJ">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.actualAmount }}</span>
              <el-input type="textarea"  v-else v-model="scope.row.displayValue"  placeholder="请输入" :autosize="{ minRows: 2, maxRows: 10 }"
              @focus="handleFocus(scope.row)" @blur="handleBlur(scope.row)" v-expression-input
               v-zero size="mini"></el-input>
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="actualAmount" width="120" label="实际收支(万元)" v-if="isTZ">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.actualAmount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="flowItemId" min-width="140" label="现金流项目">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ scope.row.flowItemName }}</span>
              <el-select v-else v-model="scope.row.flowItemId" placeholder="请选择" size="mini" @change="zuzhiChange(scope.row,)">
                <el-option  v-for="item in BMlist"  :key="item.id"  :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="itemName" width="90" label="项目名称">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ scope.row.itemName }}</span>
              <el-input v-else v-model="scope.row.itemName" placeholder="请输入" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="debtAmount" min-width="75" label="总欠款(万元)">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||isSJ">{{ scope.row.debtAmount }}</span>
              <el-input v-else v-model="scope.row.debtAmount" placeholder="请输入" v-zero size="mini" v-number-input.float="4"></el-input>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="paymentCycle" width="110" label="收付款周期">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ scope.row.paymentCycle }}</span>
              <el-date-picker
                v-else
                v-model="scope.row.paymentCycle"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                size="mini"
                placeholder="请选择">
              </el-date-picker>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column prop="supplierName" min-width="140" label="供应商">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ scope.row.supplierName }}</span>
              <el-input v-else v-model="scope.row.supplierName" placeholder="请输入" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="paymentMethods" width="80" label="收支方式">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ ['现金' ,'承兑','现汇'][scope.row.paymentMethods] }}</span>
              <el-select v-else v-model="scope.row.paymentMethods" placeholder="请选择" size="mini">
                <el-option label="现金" value="0" ></el-option>
                <el-option label="承兑" value="1" ></el-option>
                <el-option label="现汇" value="2" ></el-option>
              </el-select>
             </div>
            <!-- 0：现金 1：承兑 2：现汇 -->
          </template>
        </el-table-column>
         <el-table-column prop="predictedAmount" min-width="110" label="计划收支合计(万元)">
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.predictedAmount}}</span>
             </div>
          </template>
        </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" min-width="80">
            <template slot-scope="scope">
              <div>
                <span v-if="!scope.row.isEditing||isSJ">{{ scope.row.cycleAmounts[item.valueKey] }}</span>
                <el-input v-else v-model="scope.row.cycleAmounts[item.valueKey]" v-zero @input="handleCycleAmount(scope.row, item, $event)" v-number-input.float="4" placeholder="请输入" size="mini"></el-input>
              </div>
            </template>
          </el-table-column>
        </template>
         <el-table-column prop="invoiceStatus" width="90" label="开票情况">
          <template slot-scope="scope">
            <!-- 0：已开票 1：款到发货 2：预付款 -->
             <div>
               <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ ['已开票' ,'款到发货','预付款'][scope.row.invoiceStatus] }}</span>
                <el-select v-else v-model="scope.row.invoiceStatus" placeholder="请选择" size="mini">
                <el-option label="已开票" value="0" ></el-option>
                <el-option label="款到发货" value="1" ></el-option>
                <el-option label="预付款" value="2" ></el-option>
              </el-select>
             </div>
          </template>
        </el-table-column>

        <el-table-column prop="remark" width="100" label="备注">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing||(isSJ&&scope.row.id)">{{ scope.row.remark }}</span>
              <el-input v-else v-model="scope.row.remark" placeholder="请输入" size="mini"></el-input>
             </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
    </div>
    <el-dialog  title="调整备注" :close-on-click-modal="false" append-to-body :close-on-press-escape="false"  @close="TZflag = false"  :visible.sync="TZflag" width="400px" center>
      <div>
        <el-form  :inline="true"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="调整备注" class="item1" prop="handleRemark">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="adjustRemark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TZflag = false">取 消</el-button>
        <el-button type="primary" @click="TZsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <tiaozhengjilu v-if="jiluMark" :jiluMark.sync="jiluMark" :rowData="currentEditingRow"  ></tiaozhengjilu>
  </el-dialog>
</template>

<script>
import { findCashFlowItemLists, weekDetailList, saveWeeklyFundPlanDetail, delWeeklyFundPlanDetail, saveWeeklyFundPlanDetailForSjsz, saveWeeklyDetailCheck,
  saveWeeklyFundPlanDetailForTz, delWeeklyFundPlanDetailForTz
} from '@/api/common-signature'
import tiaozhengjilu from '@/views/common-signature/fundingPlan/public/tiaozhengjilu.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'monthPlanDialog',
  components: { tiaozhengjilu },
  data () {
    return {
      tableDataList: [],
      rules: {},
      BMlist: [],
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        yearMonthDate: ''
      },
      tableHeadList: [],
      detailForm: {
        pageNo: 1,
        pageSize: 200,
        monthlyPlanMasterId: '',
        cycleMasterId: '',
        incomeExpenseType: ''
      },
      tableHeight: 500,
      tableKey: 0,
      currentEditingRow: null, // 当前正在编辑的行
      isSJ: this.rowData ? this.rowData.isSJ : false, // 是否实际收支
      isTZ: this.rowData ? this.rowData.isTZ : false, // 是否调整
      adjustRemark: '',
      TZflag: false,
      jiluMark: false,
      mapData: {},
      isDisable: false
    }
  },
  props: {
    title: {
      type: String
    },
    dialogMonth: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
    const handleKeyDown = (e) => {
      // 只处理输入框
      if (document.activeElement.tagName !== 'INPUT') return

      const input = document.activeElement
      const inputs = Array.from(document.querySelectorAll('.el-table input'))
      const idx = inputs.indexOf(input)

      if (idx === -1) return

      // 自动获取当前行有多少列
      const tr = input.closest('tr')
      const colLength = tr ? tr.querySelectorAll('input').length : 0
      if (colLength === 0) return

      // 上下左右逻辑
      const keyMap = {
        ArrowUp: -colLength,
        ArrowDown: colLength,
        ArrowLeft: -1,
        ArrowRight: 1
      }

      const step = keyMap[e.key]
      if (step === undefined) return

      e.preventDefault()

      const nextInput = inputs[idx + step]
      if (nextInput) nextInput.focus()
    }

    document.addEventListener('keydown', handleKeyDown)

    // 页面销毁时移除监听（防止内存泄漏）
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleKeyDown)
    })
  },
  created () {
    // this.findCashFlowItemLists(true)
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  watch: {
    tableHeadList: {
      handler (newVal) {
        if (newVal && newVal.length > 0 && this.tableDataList.length > 0) {
        // 当表头变化时，确保每行数据都有对应的动态列值
          this.tableDataList.forEach(row => {
            if (!row.cycleAmounts) {
              row.cycleAmounts = {}
            }
            newVal.forEach(header => {
              if (row.cycleAmounts[header.valueKey] === undefined) {
                this.$set(row.cycleAmounts, header.valueKey, '')
              }
            })
          })
        }
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async daochuFn () {
      this.isDisable = true

      let form = { weeklyPlanMasterId: this.rowData.id }
      await exportExcel(
        this.global.smpName + '/weeklyFundPlanMaster/exportDetailList',
        form,
        '周资金计划明细'
      )
      this.isDisable = false
    },
    // 获取焦点：显示表达式
    handleFocus (row) {
      this.$set(row, 'displayValue', row.actualFormula || row.actualAmount || '')
      this.$forceUpdate()
    },

    // 失去焦点：计算并保存
    handleBlur (row) {
      const expression = row.displayValue
      const result = this.calculateExpression(expression)
      this.$set(row, 'actualFormula', expression)
      this.$set(row, 'actualAmount', result)
      this.$set(row, 'displayValue', result)

      this.$forceUpdate()
    },
    // 计算加减法表达式
    calculateExpression (expr) {
      if (!expr || expr.trim() === '') return '0'

      try {
        let formula = expr.replace(/\s/g, '')

        // 只允许数字、小数点、+、-
        if (!/^[0-9+\-.]*$/.test(formula)) {
          return expr
        }

        // 如果以运算符结尾，去掉末尾的运算符
        if (formula.endsWith('+') || formula.endsWith('-')) {
          formula = formula.slice(0, -1)
        }

        // 如果去掉运算符后为空，返回 '0'
        if (formula === '' || formula === '+' || formula === '-') {
          return '0'
        }

        // 拆分表达式，逐个计算加减法
        const numbers = []
        let currentNumber = ''

        for (let i = 0; i < formula.length; i++) {
          const char = formula[i]
          if (char === '+' || char === '-') {
            if (currentNumber !== '') {
              const num = parseFloat(currentNumber)
              if (!isNaN(num)) {
                numbers.push(num)
              }
              currentNumber = ''
            }
            currentNumber = char
          } else if (/[0-9.]/.test(char)) {
            currentNumber += char
          }
        }

        if (currentNumber !== '') {
          const num = parseFloat(currentNumber)
          if (!isNaN(num)) {
            numbers.push(num)
          }
        }

        if (numbers.length === 0) {
          return '0'
        }

        let total = 0
        for (let i = 0; i < numbers.length; i++) {
          total += numbers[i]
        }

        return parseFloat(total.toFixed(4)).toString()
      } catch (e) {
        return expr
      }
    },
    tiaozhengjiluFN (row) {
      this.jiluMark = true
      this.currentEditingRow = row
    },
    setRowStyle ({ row, index }) {
      if (row.adjustFlag === '1') {
        return {
          background: '#F56C6C' // 浅红色背景（可自定义）
        }
      }
      return {}
    },
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 600

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = 600
      }

      this.tableHeight = baseHeight
    },
    // 小星星
    addStar (obj) {
      if (obj.column.property == 'incomeExpenseType' || obj.column.property == 'flowItemId' || obj.column.property == 'itemName' || obj.column.property == 'supplierName' || obj.column.property == 'paymentMethods') {
        return 'star'
      }
      if (obj.column.label && obj.column.label.includes('-')) {
        return 'star'
      }
    },
    detailList () {
      let lastScrollTop = 0
      if (this.$refs.table) {
        lastScrollTop = this.$refs.table.bodyWrapper.scrollTop
      }

      this.$set(this.detailForm, 'weeklyPlanMasterId', this.rowData.id)
      weekDetailList(this.detailForm)
        .then(res => {
          console.log(res)
          this.mapData = res.tWeeklyFundPlanMaster
          this.tableHeadList = res.titleList || []
          if (res.pageInfo && res.pageInfo.list && res.pageInfo.list.length > 0) {
            // 处理数据，确保动态列的值正确绑定
            this.tableDataList = res.pageInfo.list.map(item => {
              // 确保 cycleAmounts 存在
              if (!item.cycleAmounts) {
                item.cycleAmounts = {}
              }

              // 将动态表头对应的值赋值给 cycleAmounts
              if (this.tableHeadList && this.tableHeadList.length > 0) {
                this.tableHeadList.forEach(header => {
                  // 如果返回的数据中有动态列的值，将其放入 cycleAmounts
                  if (item[header.valueKey]) {
                    item.cycleAmounts[header.valueKey] = item[header.valueKey]
                  } else {
                    // 如果没有值，设置为空字符串
                    item.cycleAmounts[header.valueKey] = 0
                  }
                })
              }
              item.debtAmount = item.debtAmount ? item.debtAmount : 0
              item.isEditing = false
              // 为每行数据计算预估收支合计
              // this.calculatePredictedAmount(item)
              return item
            })
            // 还原位置
            this.$nextTick(() => {
              if (this.$refs.table) {
                requestAnimationFrame(() => {
                  this.$refs.table.bodyWrapper.scrollTop = lastScrollTop
                })
              }
            })
          } else {
            // 如果没有数据，创建一个空行，并初始化动态列的值
            let objData = {
              incomeExpenseType: '',
              flowItemId: '',
              flowItemName: '',
              itemName: '',
              invoiceStatus: '',
              debtAmount: 0,
              supplierName: '',
              paymentMethods: '',
              predictedAmount: 0,
              remark: '',
              cycleAmounts: {},
              isEditing: true
            }

            // 初始化动态表头对应的空值
            if (this.tableHeadList && this.tableHeadList.length > 0) {
              this.tableHeadList.forEach(header => {
                objData.cycleAmounts[header.valueKey] = 0
              })
            }
            this.tableDataList = [objData]
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.doLayout()
              }
            })
          }
          // console.log('处理后的表格数据:', this.tableDataList)
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    findCashFlowItemLists (n) {
      findCashFlowItemLists({ cashFlowType: n }).then((res) => {
        if (res.length > 0) {
          this.BMlist = res
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    shouzhiChange (row) {
      this.$set(row, 'flowItemName', null)
      this.$set(row, 'flowItemId', null)
      this.findCashFlowItemLists(row.incomeExpenseType == '0' ? 1 : 2)
    },
    zuzhiChange (row) {
      let json = this.BMlist.find(itme => itme.id == row.flowItemId)
      console.log(json)
      this.$set(row, 'flowItemName', json.name)
      // this.$nextTick(() => {
      //   const cascaderInstance = this.$refs.zuzhicascader // 假设你的el - cascader组件有ref="cascader"
      //   const checkedNodes = cascaderInstance.getCheckedNodes()[0]
      //   console.log(checkedNodes)
      //   this.$set(row, 'flowItemName', checkedNodes.data.name)
      //   this.$set(row, 'flowItemId', checkedNodes.data.id)
      // })
    },
    handleCycleAmount (row, item, value) {
      // console.log(row, item, value)
      this.$set(row, item.valueKey, value)
      this.$set(row, item.key, item.id)
      this.$set(row.cycleAmounts, item.valueKey, value)
      // 自动计算预估收支合计
      this.calculatePredictedAmount(row)
    },
    // 计算预估收支合计
    calculatePredictedAmount (row) {
      if (!row.cycleAmounts) {
        row.predictedAmount = ''
        return
      }

      let total = 0
      let hasValue = false

      // 遍历所有周期列，累加值
      this.tableHeadList.forEach(item => {
        const value = row.cycleAmounts[item.valueKey]
        if (value && value !== '' && !isNaN(parseFloat(value))) {
          total += parseFloat(value)
          hasValue = true
        }
      })

      // 设置合计值，如果没有值则清空
      if (hasValue) {
        row.predictedAmount = parseFloat(total.toFixed(4))
      } else {
        row.predictedAmount = ''
      }
    },
    closeadd () {
      this.currentEditingRow = null
      this.$emit('update:dialogMonth', false)
    },
    // 复制
    fuzhiFn (row) {
      if (!this.validateRow(row, true)) {
        return
      }
      const hasTrue = this.tableDataList.some(item => item.isEditing === true)
      if (hasTrue) {
        this.$message.error('有未保存的数据，请先保存再新增行')
        return
      }
      // 获取当前行的索引
      this.findCashFlowItemLists(row.incomeExpenseType == '0' ? 1 : 2)
      // 创建新的空行数据
      const newRow = JSON.parse(JSON.stringify(row))
      newRow.isEditing = true
      delete newRow.id
      // 初始化动态表头对应的空值
      if (this.tableHeadList && this.tableHeadList.length > 0) {
        this.tableHeadList.forEach(header => {
          newRow.cycleAmounts[header.valueKey] = 0
          this.$set(newRow, header.valueKey, 0)
        })
      }
      this.$set(newRow, 'predictedAmount', 0)
      this.$set(newRow, 'debtAmount', 0)
      this.$set(newRow, 'itemName', '')
      this.$set(newRow, 'supplierName', '')
      this.$set(newRow, 'remark', '')
      this.$set(newRow, 'bmPredictedAmount', 0)
      this.tableDataList.push(newRow)
      // 重新渲染表格
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })
    },
    addRowFn (row) {
      if (!this.validateRow(row, true)) {
        return
      }
      const hasTrue = this.tableDataList.some(item => item.isEditing === true)
      if (hasTrue) {
        this.$message.error('有未保存的数据，请先保存再新增行')
        return
      }
      // if (row.isEditing) {
      //   this.$message.error('请先保存当前行的编辑')
      //   return
      // }
      // 获取当前行的索引
      const currentIndex = this.tableDataList.findIndex(item => item === row)
      // 创建新的空行数据
      const newRow = {
        incomeExpenseType: '',
        flowItemId: '',
        flowItemName: '',
        itemName: '',
        invoiceStatus: '',
        debtAmount: 0,
        supplierName: '',
        paymentMethods: '',
        predictedAmount: 0,
        remark: '',
        cycleAmounts: {},
        isEditing: true
      }
      if (this.isSJ) {
        newRow.debtAmount = 0
        newRow.predictedAmount = 0
      }
      // 初始化动态表头对应的空值
      if (this.tableHeadList && this.tableHeadList.length > 0) {
        if (this.isSJ) {
          this.tableHeadList.forEach(header => {
            newRow.cycleAmounts[header.valueKey] = 0
          })
        } else {
          this.tableHeadList.forEach(header => {
            newRow.cycleAmounts[header.valueKey] = 0
          })
        }
      }

      // 在当前行的后面插入新行
      if (currentIndex !== -1) {
        this.tableDataList.splice(currentIndex + 1, 0, newRow)
      } else {
        // 如果没找到当前行，则在最后添加
        this.tableDataList.push(newRow)
      }

      // 重新渲染表格
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })

      // console.log('新增行成功:', newRow)
    },
    // 删除
    delMaterial (row, index) {
      let isClose = false
      if (this.tableDataList.length == 1) {
        isClose = true
      }
      if (!row.id) {
        this.tableDataList.splice(index, 1)
        if (isClose) {
          this.closeadd()
          this.$parent.searchFn()
        }
      } else {
        if (this.isTZ || this.isSJ) {
          this.TZflag = true
          this.currentEditingRow = row
          this.adjustRemark = ''
        } else {
          this.$confirm('是否执行删除操作？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            delWeeklyFundPlanDetail({
              id: row.id,
              weeklyPlanMasterId: row.weeklyPlanMasterId
            })
              .then(res => {
                loading.close()
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                if (isClose) {
                  this.closeadd()
                  this.$parent.searchFn()
                }
                this.detailList()
              })
              .catch(err => {
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          })
        }
      }
    },
    editClick (row, index) {
      const hasTrue = this.tableDataList.some(item => item.isEditing === true)
      if (hasTrue) {
        this.$message.error('有未保存的数据，请先保存再修改')
        return
      }
      // 设置当前行为编辑状态
      row.isEditing = true
      this.currentEditingRow = row
      this.findCashFlowItemLists(row.incomeExpenseType == '0' ? 1 : 2)

      this.$nextTick(() => {
        // 如果有保存过的表达式，显示表达式；否则显示当前值
        this.$set(row, 'displayValue', row.actualAmount || '')
        // 如果没有 actualFormula，用当前值初始化
        if (!row.actualFormula && row.actualAmount) {
          this.$set(row, 'actualFormula', row.actualAmount)
        }
      })
    },
    validateRow (row, rowAddFlag) {
    // 1. 收支类型
      if (!row.incomeExpenseType) {
        if (!rowAddFlag) this.$message.error('收支类型不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 2. 现金流项目
      if (!row.flowItemId) {
        if (!rowAddFlag) this.$message.error('现金流项目不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 3. 项目名称
      if (!row.itemName) {
        if (!rowAddFlag) this.$message.error('项目名称不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // // 4. 收付款周期
      // if (!row.paymentCycle) {
      //   if (!rowAddFlag) this.$message.error('收付款周期不能为空')
      //   if (rowAddFlag) this.$message.error('请完整维护当前行数据')
      //   return
      // }
      // 5. 供应商
      if (!row.supplierName) {
        if (!rowAddFlag) this.$message.error('供应商不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 6. 收支方式
      if (!row.paymentMethods) {
        if (!rowAddFlag) this.$message.error('收支方式不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }

      // 7. 动态周期列校验
      const errors = []
      // 存储所有周期列的值，用于判断是否全为0
      const cycleValues = []

      if (this.tableHeadList && this.tableHeadList.length > 0) {
        this.tableHeadList.forEach(item => {
          // 从 row.cycleAmounts 中获取值
          const value = row.cycleAmounts && row.cycleAmounts[item.valueKey]
          // 把值存入数组，用于后续全0判断
          cycleValues.push(value)

          // 原有校验：检查值是否为空（包括空字符串、null、undefined）
          if (value === '' || value === null || value === undefined) {
            if (!rowAddFlag) {
              errors.push(`${item.name}不能为空`)
            }
            if (rowAddFlag) {
              errors.push(`${item.name}请完整维护当前行数据`)
            }
          }
        })
      }

      // 新增校验：所有周期列不能全部为 0
      // 只有当没有空值错误时，才校验全0（避免重复提示）
      if (errors.length === 0 && cycleValues.length > 0) {
        // 判断是否所有值都等于 0
        const isAllZero = cycleValues.every(val => Number(val) === 0)

        if (isAllZero && !this.isSJ && !this.isTZ) {
          errors.push('周期列数据不能全部为0，请至少维护一项')
        }
      }

      // 如果有错误，显示错误信息并停止执行
      if (errors.length > 0) {
        // 显示所有错误信息，每个错误单独一行
        const errorMsg = errors.join('\n')
        if (!rowAddFlag) this.$message.error(`\n${errorMsg}`)
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      return true
    },
    // 保存
    submitClick (row) {
      if (!this.validateRow(row)) {
        return
      }
      // 校验通过，执行保存
      this.saveWeeklyFundPlanDetail(row)
      // 所有校验通过，执行保存操作
      console.log('校验通过，开始保存', row)
    },
    saveWeeklyFundPlanDetail (row) {
      this.$set(row, 'weeklyPlanMasterId', this.rowData.id)
      this.$set(row, 'monthlyPlanMasterId', this.rowData.monthlyPlanMasterId)
      this.$set(row, 'cycleDetailId', this.rowData.cycleDetailId)
      this.$set(row, 'actualAmount', row.actualAmount ? row.actualAmount : 0)
      this.$set(row, 'tenantFaction', this.rowData.tenantFaction)
      if (this.isSJ) { // 实际收支走另一个接口
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        saveWeeklyFundPlanDetailForSjsz(row)
          .then(res => {
            loading.close()
            console.log(res)
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            if (row.isEditing) {
              row.isEditing = false
              this.currentEditingRow = null
            }
            this.detailList()
            // this.closeadd()
            this.$parent.searchFn()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      } else if (this.isTZ) {
        this.TZflag = true
        this.currentEditingRow = row
        this.adjustRemark = ''
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        saveWeeklyDetailCheck(row)
          .then(res => {
            loading.close()
            if (res) {
              this.$confirm(res, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                this.jiekou(row)
              })
            } else {
              this.jiekou(row)
            }
          }).catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    TZsaveFn () {
      if (!this.adjustRemark) {
        this.$message.error('请输入调整备注')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.currentEditingRow.isEditing) { // 修改保存
        this.currentEditingRow.adjustRemark = this.adjustRemark
        saveWeeklyFundPlanDetailForTz(this.currentEditingRow)
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.TZflag = false
            if (this.currentEditingRow.isEditing) {
              this.currentEditingRow.isEditing = false
              this.currentEditingRow = null
            }
            this.detailList()
            // this.closeadd()
            this.$parent.searchFn()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      } else { // 删除
        delWeeklyFundPlanDetailForTz({
          id: this.currentEditingRow.id,
          weeklyPlanMasterId: this.currentEditingRow.weeklyPlanMasterId,
          adjustRemark: this.adjustRemark,
          sjszTzFlag: this.isTZ ? 1 : 0
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.TZflag = false
            if (this.currentEditingRow.isEditing) {
              this.currentEditingRow.isEditing = false
              this.currentEditingRow = null
            }
            this.detailList()
            // this.closeadd()
            this.$parent.searchFn()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 编写修改接口
    jiekou (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      saveWeeklyFundPlanDetail(row).then(res => {
        loading.close()
        console.log(res)
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        if (row.isEditing) {
          row.isEditing = false
          this.currentEditingRow = null
        }
        this.detailList()
        // this.closeadd()
        this.$parent.searchFn()
      }).catch(err => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  },
  // ：聚焦清空0，失焦空值补0
  directives: {
    zero: {
      bind (el) {
        const input = el.querySelector('input') || el.querySelector('textarea')
        input.onfocus = () => {
          if (input.value == 0) input.value = ''
        }
        input.onblur = () => {
          if (input.value === '' || input.value == null) input.value = 0
        }
      }
    },
    // 👇 新增这个指令
    'expression-input': {
      bind (el) {
        const input = el.querySelector('input') || el.querySelector('textarea')
        if (!input) return

        let isComposing = false // 标记是否正在使用输入法组合输入

        // 监听组合输入开始
        input.addEventListener('compositionstart', () => {
          isComposing = true
        })

        // 监听组合输入结束
        input.addEventListener('compositionend', (e) => {
          isComposing = false
          // 组合输入结束后，再处理一次过滤
          filterInput(e)
        })

        const filterInput = (e) => {
          let value = e.target.value
          if (value === '') {
            e.target._lastValue = value
            return
          }

          // 只允许数字、小数点、+、-
          const allowedRegex = /^[0-9+\-.]*$/

          if (!allowedRegex.test(value)) {
            // 过滤掉非法字符，保留合法字符
            const newValue = value.replace(/[^0-9+\-.]/g, '')
            e.target.value = newValue

            // 触发 input 事件更新 v-model
            const event = new Event('input', { bubbles: true })
            e.target.dispatchEvent(event)
            return
          }

          e.target._lastValue = value
        }

        const handleInput = (e) => {
          // 如果正在使用输入法组合输入（比如打拼音），不进行过滤
          if (isComposing) {
            return
          }
          filterInput(e)
        }

        input.addEventListener('input', handleInput)

        // 保存清理函数
        input._handleInput = handleInput
        input._compositionStart = () => { isComposing = true }
        input._compositionEnd = (e) => {
          isComposing = false
          filterInput(e)
        }
        input.addEventListener('compositionstart', input._compositionStart)
        input.addEventListener('compositionend', input._compositionEnd)
      },
      unbind (el) {
        const input = el.querySelector('input') || el.querySelector('textarea')
        if (input) {
          if (input._handleInput) {
            input.removeEventListener('input', input._handleInput)
          }
          if (input._compositionStart) {
            input.removeEventListener('compositionstart', input._compositionStart)
          }
          if (input._compositionEnd) {
            input.removeEventListener('compositionend', input._compositionEnd)
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
::v-deep .el-textarea__inner {
  resize: none !important;
  overflow-y: hidden !important;  /* 隐藏滚动条，让高度自动撑开 */
}
</style>
